/**
 * [Insider+] Outer-portal / Discourse entry detection + landing-page seeding.
 */

import TagManager from 'react-gtm-module';
import { INSIDER_PLUS_PAGE } from '../../constants/pages';
import {
  INSIDER_PLUS_ENTRY_SOURCE,
  LANDING_PAGE,
} from '../../constants/sessionStorage';
import { storeInSessionStorage } from './sessionStorageHelper';

const INSIDER_PLUS_CLICKED_PARAM = 'InsiderPlusClicked';
export const OUTER_PORTAL_SOURCE = 'outer_portal';
export const DISCOURSE_SOURCE = 'discourse';

// Detects the ?InsiderPlusClicked=yes deep-link from the marketing site
// (goldsilver.com) and seeds the existing post-login landing-page flow so
// the user ends up on /insider-plus after login + 2FA. Mirrors the BUY
// default in landingPageHelper.
export const handleInsiderPlusEntry = () => {
  if (typeof window === 'undefined') return null;

  const url = new URL(window.location.href);
  const flag = url.searchParams.get(INSIDER_PLUS_CLICKED_PARAM);
  if (flag !== 'yes') return null;

  storeInSessionStorage(LANDING_PAGE, INSIDER_PLUS_PAGE);
  storeInSessionStorage(INSIDER_PLUS_ENTRY_SOURCE, OUTER_PORTAL_SOURCE);

  // Rewrite to /insider-plus so PrivateRoute resolves against the right
  // path (unauth: stores it as LANDING_PAGE; auth: renders directly).
  url.pathname = INSIDER_PLUS_PAGE;
  url.searchParams.delete(INSIDER_PLUS_CLICKED_PARAM);
  window.history.replaceState({}, '', url.toString());

  TagManager.dataLayer({
    dataLayer: {
      event: 'insider_plus_entry',
      source: OUTER_PORTAL_SOURCE,
    },
  });

  return OUTER_PORTAL_SOURCE;
};
